import StatusTransitionsService from '../../components/services/StatusTransitionsService';

export async function getFieldFillingControlStandalone(
  transitionId: number,
  statusTransitionsService: StatusTransitionsService
) {
  try {
    const serviceResult = await statusTransitionsService.get(transitionId);
    const result = await serviceResult.result;
    if (result && result.fieldFillingControls) {
      return result.fieldFillingControls;
    }
    return [];
  } catch (error) {
    console.error('Error fetching field filling controls:', error);
    return [];
  }
}
